(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["carzilla-stock-note"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('carzilla-stock-note')) {
    customElements.define('carzilla-stock-note', class extends HTMLElement {
      connectedCallback() {
        this.productSection = this.closest('.product-section');
        if (!this.productSection) return;
        this.onVariantChange = (event) => {
          const variant = event.detail && event.detail.variant;
          this.hidden = !(variant && variant.available && variant.requires_shipping);
        };
        this.productSection.addEventListener('variantChange', this.onVariantChange);
      }
      disconnectedCallback() {
        if (this.productSection && this.onVariantChange) {
          this.productSection.removeEventListener('variantChange', this.onVariantChange);
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["multi-selectors"] && !Shopify.designMode) return;
  try {
    (() => {
    const context = document.modelContext;
    if (!context || typeof context.registerTool !== 'function') return;

    const selector = '[data-native-country-webmcp]';
    const optionSelector = 'a[data-disclosure-option][data-value]';

    const registerCountryTool = async () => {
      const disclosure = document.querySelector(selector);
      if (!disclosure) return;

      const options = Array.from(disclosure.querySelectorAll(optionSelector));
      if (!options.length || !disclosure.querySelector('[name="country_code"]')) return;

      try {
        await context.registerTool({
          name: 'carzilla_change_country',
          description: disclosure.dataset.nativeCountryWebmcp,
          inputSchema: {
            type: 'object',
            properties: {
              country_code: {
                type: 'string',
                enum: options.map(option => option.dataset.value),
                description: options.map(option => `${option.dataset.value}: ${option.getAttribute('aria-label')}`).join('; ')
              }
            },
            required: ['country_code'],
            additionalProperties: false
          },
          annotations: { readOnlyHint: false, consequentialHint: false },
          execute: async ({ country_code }, { signal } = {}) => {
            if (signal && signal.aborted) return { error: 'cancelled' };
            const currentDisclosure = document.querySelector(selector);
            const input = currentDisclosure && currentDisclosure.querySelector('[name="country_code"]');
            const option = currentDisclosure && Array.from(currentDisclosure.querySelectorAll(optionSelector))
              .find(item => item.dataset.value === country_code);

            if (!input || !option) return { error: 'country_unavailable' };
            if (input.value === country_code) return { country_code, status: 'already_selected' };

            option.click();
            return { country_code, status: 'selection_submitted' };
          }
        });
      } catch {
        return;
      }
    };

    if (document.readyState === 'complete') {
      registerCountryTool();
    } else {
      window.addEventListener('load', registerCountryTool, { once: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
